<style lang='scss' scoped>
.syslist {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    white-space: nowrap;
    background-color: #09659A;
    box-shadow: 0 0 2px #ccc;
    color: #fff;
    font-size: 13px;
    min-width: 560px;
    .syslist-search {
        margin: 20px;
    }
    .syslist-content {
        padding: 12px 20px;
        height: 300px;
        overflow: auto;
    }
    div {
        display: table-row;
        line-height: 36px;
        &:hover {
            color: #4093ff;
        }
    }
    span {
        display: table-cell;
        min-width: 100px;
        padding: 0 10px;
    }
    footer {
        text-align: center;
        padding: 60px;
        font-size: 16px;
    }
}
</style>


<template>
	<div class="syslist" @click.stop>
		<vInput
			v-model="searchName"
			class="syslist-search"
			:placeholder="$t('global.nav.shorttip')"
			@on-change="getSysList()"
			@on-enter="getSysList()"
		></vInput>
		<aside class="syslist-content" v-scroll-load-vview="loadingList">
			<template v-if="syslist.length>0">
				<div v-for="item in syslist" @click.stop="handleUserInfo(item)">
					<span>id:{{item.id}}</span>
					<span>{{$t('global.common.organization')}}:{{item.name}}</span>
					<span>code:{{item.code}}</span>
				</div>
			</template>
			<footer v-else>{{$t('global.common.nodata')}}</footer>
		</aside>
	</div>
</template>

<script>
import { HttpSystemList } from '../../../../service/base';
import { mapActions, mapMutations } from 'vuex';
export default {

	data() {
		return {
			syslist: [],
			page: 1,
			searchName: '',
		};
	},
	created() {
		this.getSysList();
	},
	methods: {
		...mapActions(['actionInitBaseData']),
		...mapMutations(['setOrganization']),
		handleUserInfo(item) {
			sessionStorage.removeAll('', true);
			localStorage.removeAll('', true);
			localStorage.setItem('TEMP_CHEAR_SESSION', true, { scope: '', version: '' });
			localStorage.removeItem('TEMP_CHEAR_SESSION');
			this.$nextTick(() => {
				this.$parent.visible = false;
                // this.setOrganization({ id: item.id, name: item.name, logoUrl: item.logo || '', attach: { ...item } });
                this.setOrganization({
                    ...item,
                    logoUrl: item.logo
                });
				this.actionInitBaseData({ updateInit: true });
			})
		},
		getSysList(loading) {
			if (!loading) this.page = 1;
			return HttpSystemList({
				rows: 20,
				page: this.page,
				sidx: 'id',
				sord: 'desc',
				search: {
					CN_name: this.searchName,
					EQ_status: 1
				}
			}).then((res) => {
				const data = res.data.content || [];
				this.syslist = loading ? [...this.syslist, ...data] : data;
			}, () => {

			});
		},
		loadingList() {
			this.page += 1;
			this.getSysList(true)
		},
	},


};
</script>
